import { HttpInterceptorFn } from '@angular/common/http';
import {UserService} from "./user.service";
import {inject} from "@angular/core";
import {from, switchMap} from "rxjs";

export const headersInterceptor: HttpInterceptorFn = (req, next) => {

  const userService = inject(UserService);
  return from(userService.getJWT()).pipe(
    switchMap((authToken) => {
      // S3 calls should not have auth header
      if (req.url.indexOf('s3.eu-central-1.amazonaws.com') === -1 && req.url.indexOf('s3.eu-south-1.amazonaws.com') === -1) {
        // Clone the request and add the authorization header
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`
          }
        });

        // Pass the cloned request with the updated header to the next handler
        return next(authReq);
      } else {
        return next(req);
      }
    })
  )
};
